<app-header></app-header>
<div class="content small-head">
  <mat-card appearance="outlined" class="info-card">
    <mat-card-content>
      @if (passedparam) {
        <div class="passed">
          <h3>{{'ExamPassed' | translate }}</h3>
          <p>{{'TrainingRefreshed' | translate: {trainDesc : traiDesc } }}</p>
          <!-- <h3 [translate]="'[innerHtml]TrainingRefreshed'" [translateParams]="{trainDesc: 'Andreas'}"></h3> -->
          <span class="material-icons-round allow">
            verified
          </span>
          <h4>{{'ExamResult' | translate }}: {{percentOfCompletion}}%</h4>
          <a [routerLink]="['/bookselect']"><button mat-raised-button color="primary">{{'OtherTraining' | translate }}</button></a>
        </div>
      } @else {
        <div class="not-passed">
          <h3>{{'ExamNotPassed' | translate }}</h3>
          <p>{{'TrainingFailedInfo' | translate: {trainDesc : traiDesc } }}</p>
          <span class="material-icons-round not-allow">
            block
          </span>
          <h4>{{'ExamResult' | translate }}: {{percentOfCompletion}}%</h4>
          @if (isYMUser) {
            <div>
              <a [routerLink]="['/videotraining']"><button mat-raised-button color="primary">{{'TryAgain' | translate }}</button></a>
            </div>
          } @else {
            <a [routerLink]="['/bookselect']"><button mat-raised-button color="primary">{{'TryAgain' | translate }}</button></a>
            <!-- <a [routerLink]="['/']"><button mat-raised-button color="primary">{{'ExamResult' | translate }}</button></a> -->
          }
        </div>
      }
    </mat-card-content>
    <mat-card-footer>
    </mat-card-footer>
  </mat-card>
</div>